import { Controller } from 'stimulus';

export default class extends Controller {
  static values = { location: String }

  connect() {
    setTimeout(() => window.location.href = this.locationValue, 100);
  }
}